'use es6';

import { Record } from 'immutable';
import { RequestStatus } from '../constants/base';
const DEFAULTS = {
  hasData: false,
  status: RequestStatus.UNINITIALIZED
};
class SmartContentActivities extends Record(DEFAULTS) {
  static fromJS({
    breakdowns
  }) {
    return new SmartContentActivities({
      hasData: breakdowns.length > 1,
      status: RequestStatus.SUCCEEDED
    });
  }
}
export default SmartContentActivities;